import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { getHelpText } from 'z3k-settings/components/utils/help-content';
import { Box } from '@mui/material';
import { ErrorOutlined, ReportProblemOutlined } from '@mui/icons-material';
import { orange, red } from '@mui/material/colors';
import { HelpIcon } from './help-icon';
export const LabelWithIcon = memo(function LabelWithIcon(props) {
    const { help_id, help_options, label, has_error, has_warning } = props;
    const show_help_icon = useMemo(() => help_id != null && getHelpText(help_id, help_options ?? null) !== null, [help_id, help_options]);
    return (_jsxs(Box, { display: "flex", flexWrap: "nowrap", alignItems: "center", width: "100%", gap: 1, minHeight: !show_help_icon ? 'calc(1em * 1.25 + 6px)' : undefined, children: [has_error && (_jsx(ErrorOutlined, { sx: {
                    color: red[700],
                    mr: 1,
                } })), has_warning && (_jsx(ReportProblemOutlined, { sx: {
                    color: orange[700],
                    mr: 1,
                } })), label, show_help_icon && (_jsx(HelpIcon, { help_id: help_id, help_options: help_options }))] }));
});
